module.exports = __webpack_public_path__ + "static/daymoon-18dc36683a19fd2edb6ca93af2d624c4.gif";